import React from 'react';
import * as PropTypes from 'prop-types';
import Typography, {
  TypographyStates,
  TypographyVariants,
  TypographyWeights,
} from '../../../ui-components/Typography/Typography';
import BetaIcon, { IconSizes } from '../../Icons/Icon';
import { TRANSLATIONS } from '../../../../translations';
import Tooltip from '../../Tooltip/Tooltip';
import { TOOLTIP_POSITIONS } from '../../../../constants';

const Rating = ({ averageReview, reviewCount, href = null }) => {
  const tooltipContent = `<p class="mb-none">
      <b>${TRANSLATIONS.VERIFIED_MEANING_QUESTION}</b>
      <br />
      ${TRANSLATIONS.VERIFIED_MEANING_ANSWER}
    </p>`;

  const mapNumberToStarIconNames = (n) => {
    const nonEmptyStarsArr = new Array(parseInt(n)).fill('valutationStar1');
    n % 1 && nonEmptyStarsArr.push('valutationStar05');
    return [
      ...nonEmptyStarsArr,
      ...new Array(5 - nonEmptyStarsArr.length).fill('valutationStar0'),
    ];
  };

  const main_rating = (
    <>
      <Typography
        variant={TypographyVariants.p2}
        weight={TypographyWeights['bold']}
      >
        {averageReview}
      </Typography>
      <div className="reviews__stars">
        {mapNumberToStarIconNames(averageReview).map((iconName, i) => {
          return <BetaIcon key={i} name={iconName} size={IconSizes[16]} />;
        })}
      </div>
    </>
  );

  const verified_count = (
    <div className="reviews__verified">
      <Tooltip
        tooltipId="rating-verified"
        classNames="freedome-tooltip--verified"
        smartPlacings={[
          {
            media: '(max-width: 1024px)',
            position: TOOLTIP_POSITIONS.TOP,
          },
        ]}
        target={
          <div className="d-flex gap-base">
            <BetaIcon name={'verified'} size={IconSizes[16]} />
            <Typography
              variant={TypographyVariants.p2}
              weight={TypographyWeights['regular']}
              state={TypographyStates.underlined}
            >
              {reviewCount} {TRANSLATIONS.VERIFIED_REVIEWS}
            </Typography>
          </div>
        }
        text={tooltipContent}
      />
    </div>
  );

  const wrapped_main_rating = href ? (
    <a
      className="d-flex gap-base items-center mb-05-base decoration-none"
      href={href}
    >
      {main_rating}
    </a>
  ) : (
    <div className="d-flex gap-base items-center mb-05-base">{main_rating}</div>
  );

  const wrapped_verified_count = href ? (
    <a className="decoration-none" href={href}>
      {verified_count}
    </a>
  ) : (
    <>{verified_count}</>
  );

  return (
    <>
      {averageReview && wrapped_main_rating}

      {reviewCount && wrapped_verified_count}
    </>
  );
};

Rating.propTypes = {
  averageReview: PropTypes.number.isRequired,
  reviewCount: PropTypes.string,
};

export { Rating };
